var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBrush = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31624_85)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4066 0.305573C6.50023 0.118298 6.69164 0 6.90102 0H11.7594C12.6394 0 13.3594 0.719999 13.3594 1.60001V5.40001C13.3594 5.95229 12.9117 6.40001 12.3594 6.40001H3.15936C2.60708 6.40001 2.15936 5.95229 2.15936 5.40001V1.92C2.15936 1.13328 2.70455 0 3.49127 0H4.90103C5.15417 0 5.35938 0.205214 5.35938 0.458359C5.35938 0.94203 6.01141 1.09595 6.22771 0.663344L6.4066 0.305573ZM2.16001 10.4C2.07164 10.4 2 10.3284 2 10.24V9C2 8.44772 2.44772 8 3 8H12.2C12.7523 8 13.2 8.44771 13.2 9V9.4C13.2 9.95228 12.7523 10.4 12.2 10.4H10.24C9.67999 10.4 9.36001 10.88 9.43999 11.36L9.84001 12.96C10.4 14.48 9.19999 16 7.68001 16C6.16002 16 5.04001 14.48 5.52001 12.96L5.91998 11.36C6.00001 10.88 5.6 10.4 5.12 10.4H2.16001ZM6.96001 13.6C6.96001 14.08 7.28 14.4 7.76 14.4C8.24 14.4 8.55998 14.08 8.55998 13.6C8.55998 13.12 8.24 12.8 7.76 12.8C7.28 12.8 6.96001 13.12 6.96001 13.6Z",
    fill: "#5C5F62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31624_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrush, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/brush.1ee387b3.svg";
export { ForwardRef as ReactComponent };